import React from "react";
import {IBookingSearchResultRecordViewModel} from "../booking-search-result-record.view-model.interface";
import {NullableString} from "../../../types/nullable-types";

export enum BookingSearchStrategyType {
    ByRecordLocator = 1,
    ByEmail = 2,
    ByBookingDate = 3,
    ByContact = 4,
    ByLastName = 5,
    ByPhoneNumber = 6,
    RecentBookings = 7
}

export interface IBookingSearchResultPageViewModel {
    readonly records: IBookingSearchResultRecordViewModel[];
}

export interface IBookingSearchStrategyViewModel {
    readonly type: BookingSearchStrategyType;
    readonly name: string;
    readonly resultsDescription: string;
    readonly pages: IBookingSearchResultPageViewModel[];
    readonly hasMorePages: boolean;
    readonly hasValidFilters: boolean;
    currentPageIndex: number;
    readonly isSearchInProgress: boolean;
    getAllRecords(): IBookingSearchResultRecordViewModel[];
    renderIcon(): React.ReactElement | null;
    renderSearchFields(): React.ReactElement;
    applySearch(): Promise<void>;
    nextPage(): Promise<void>;
    clearAllFilters(): void;
    clearResults(): void;
    resetErrorsValidation(): void;
    selectedRecordKey: NullableString;
    getRecordPosition(recordIndex: number): number;
    exportCurrentResultsToCSV(): Promise<void>;
}